/**
 * Meta Pixel Form Conversion Tracking
 * Tracks form submissions from Meta (Facebook) ads
 */

(function() {
  'use strict';

  // Check if user came from Meta
  function isFromMeta() {
    const urlParams = new URLSearchParams(window.location.search);
    const referrer = document.referrer.toLowerCase();
    
    // Check for Meta click ID (fbclid)
    if (urlParams.has('fbclid')) {
      return true;
    }
    
    // Check for UTM source
    if (urlParams.get('utm_source') === 'facebook' || urlParams.get('utm_source') === 'meta') {
      return true;
    }
    
    // Check referrer
    if (referrer.includes('facebook.com') || referrer.includes('fb.com')) {
      return true;
    }
    
    // Check sessionStorage for Meta traffic (set on first visit)
    if (sessionStorage.getItem('meta_traffic') === 'true') {
      return true;
    }
    
    return false;
  }

  // Store Meta traffic in sessionStorage
  function storeMetaTraffic() {
    if (isFromMeta()) {
      sessionStorage.setItem('meta_traffic', 'true');
    }
  }

  // Flag to track if form was submitted (prevents false positives on page load)
  let formSubmitted = false;
  let conversionTracked = false; // Prevent duplicate tracking

  // Track form submission conversion
  function trackFormConversion() {
    // Only track if form was actually submitted and not already tracked
    if (!formSubmitted || conversionTracked) {
      return;
    }
    
    if (typeof fbq !== 'undefined' && isFromMeta()) {
      // Track Lead event (standard conversion event for form submissions)
      fbq('track', 'Lead', {
        content_name: 'Custom Furniture Form',
        content_category: 'Form Submission',
        source: 'Meta Ad'
      });
      
      conversionTracked = true; // Mark as tracked to prevent duplicates
      console.log('Meta Pixel: Form conversion tracked');
    }
  }

  // Detect Hulk form submission
  function setupHulkFormTracking() {
    // Check if we're on the custom page
    const isCustomPage = window.location.pathname.includes('/pages/custom') || 
                         window.location.pathname.includes('/pages/custom-furniture');
    
    if (!isCustomPage) {
      return;
    }

    // Method 1: Listen for form submission events (including Hulk forms)
    document.addEventListener('submit', function(e) {
      const form = e.target;
      if (form && form.tagName === 'FORM') {
        // Check if it's a Hulk form - multiple detection methods
        const isHulkForm = 
          // Check for Hulk-specific classes/IDs
          form.closest('[class*="hulk"]') || 
          form.closest('[id*="hulk"]') ||
          form.closest('[class*="hulk-form"]') ||
          form.closest('[id*="hulk-form"]') ||
          form.querySelector('[class*="hulk"]') ||
          form.querySelector('[id*="hulk"]') ||
          // Check for Hulk data attributes
          form.closest('[data-hulk-form]') ||
          form.hasAttribute('data-hulk-form') ||
          // Check if form is within app block container (Hulk forms are app blocks)
          form.closest('[data-app-block]') ||
          form.closest('[class*="app-block"]') ||
          // On custom page, assume any form is the Hulk form (since we know it's the only form there)
          (isCustomPage && form);
        
        if (isHulkForm) {
          formSubmitted = true; // Mark form as submitted
          console.log('Meta Pixel: Hulk form submission detected');
          // Wait a bit to ensure form submission is processed
          setTimeout(function() {
            trackFormConversion();
          }, 1500);
        }
      }
    }, true);
    
    // Also listen for button clicks on submit buttons (Hulk might use AJAX)
    document.addEventListener('click', function(e) {
      const target = e.target;
      // Check if clicked element is a submit button
      if (target && (
          target.type === 'submit' || 
          target.tagName === 'BUTTON' && target.closest('form') ||
          target.closest('button[type="submit"]')
        )) {
        const form = target.closest('form') || target.form;
        if (form) {
          // Check if it's a Hulk form
          const isHulkForm = 
            form.closest('[class*="hulk"]') || 
            form.closest('[id*="hulk"]') ||
            form.closest('[class*="hulk-form"]') ||
            form.closest('[data-hulk-form]') ||
            form.closest('[data-app-block]') ||
            (isCustomPage && form);
          
          if (isHulkForm) {
            formSubmitted = true;
            console.log('Meta Pixel: Hulk form submit button clicked');
            // Wait longer for AJAX submission
            setTimeout(function() {
              trackFormConversion();
            }, 2000);
          }
        }
      }
    }, true);

    // Method 2: Use MutationObserver to detect success messages (only after form submission)
    const observer = new MutationObserver(function(mutations) {
      // Only observe if form was submitted
      if (!formSubmitted) {
        return;
      }
      
      mutations.forEach(function(mutation) {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            // Look for success indicators (common patterns including Hulk-specific)
            const successIndicators = [
              node.textContent && (
                node.textContent.toLowerCase().includes('thank') ||
                node.textContent.toLowerCase().includes('success') ||
                node.textContent.toLowerCase().includes('submitted') ||
                node.textContent.toLowerCase().includes('received') ||
                node.textContent.toLowerCase().includes('form submitted') ||
                node.textContent.toLowerCase().includes('we received')
              ),
              node.classList && (
                node.classList.contains('success') ||
                node.classList.contains('form-success') ||
                node.classList.contains('thank-you') ||
                node.classList.contains('hulk-success') ||
                node.classList.contains('form-message-success')
              ),
              node.querySelector && (
                node.querySelector('.success') ||
                node.querySelector('.form-success') ||
                node.querySelector('.thank-you') ||
                node.querySelector('[class*="success"]') ||
                node.querySelector('[class*="hulk"]')
              ),
              // Check for Hulk-specific success attributes
              node.hasAttribute && (
                node.hasAttribute('data-form-success') ||
                node.hasAttribute('data-hulk-success')
              )
            ];

            if (successIndicators.some(indicator => indicator)) {
              // Check if it's related to a form (or on custom page, assume it's the form)
              const form = node.closest('form') || 
                          node.closest('[class*="hulk"]') ||
                          node.closest('[data-app-block]') ||
                          (isCustomPage ? document.querySelector('form') : null);
              
              if (form || isCustomPage) {
                trackFormConversion();
                observer.disconnect(); // Stop observing after tracking
              }
            }
          }
        });
      });
    });

    // Start observing the document body for changes
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });

    // Method 3: Listen for custom events that Hulk might dispatch
    const hulkEvents = [
      'hulkFormSubmitted',
      'hulk:form:submit',
      'hulk:form:success',
      'hulkFormSuccess',
      'formSubmitted', // Generic form submission event
      'formSuccess'    // Generic form success event
    ];
    
    hulkEvents.forEach(function(eventName) {
      window.addEventListener(eventName, function() {
        formSubmitted = true;
        console.log('Meta Pixel: Hulk form event detected:', eventName);
        setTimeout(function() {
          trackFormConversion();
        }, 500);
      }, true);
      
      // Also listen on document
      document.addEventListener(eventName, function() {
        formSubmitted = true;
        console.log('Meta Pixel: Hulk form event detected:', eventName);
        setTimeout(function() {
          trackFormConversion();
        }, 500);
      }, true);
    });

    // Method 4: Poll for form success (fallback) - only after form submission
    let checkCount = 0;
    const maxChecks = 20; // Check for 20 seconds
    const checkInterval = setInterval(function() {
      // Only check if form was submitted
      if (!formSubmitted) {
        return;
      }
      
      checkCount++;
      
      // Look for any success messages (including Hulk-specific)
      const successSelectors = [
        '.success',
        '.form-success',
        '.thank-you',
        '.hulk-success',
        '[class*="success"]',
        '[id*="success"]',
        '[data-form-success]',
        '[data-hulk-success]',
        '[class*="hulk"][class*="success"]'
      ];
      
      const successElements = document.querySelectorAll(successSelectors.join(', '));
      
      successElements.forEach(function(el) {
        const text = el.textContent.toLowerCase();
        // Check for success text patterns
        if (text.includes('thank') || 
            text.includes('success') || 
            text.includes('submitted') ||
            text.includes('form submitted') ||
            text.includes('we received')) {
          // Make sure it's visible (not hidden)
          const style = window.getComputedStyle(el);
          if (style.display !== 'none' && style.visibility !== 'hidden' && style.opacity !== '0') {
            trackFormConversion();
            clearInterval(checkInterval);
          }
        }
      });
      
      if (checkCount >= maxChecks) {
        clearInterval(checkInterval);
      }
    }, 1000);
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      storeMetaTraffic();
      setupHulkFormTracking();
    });
  } else {
    storeMetaTraffic();
    setupHulkFormTracking();
  }
})();
